<script lang="ts">
  import type { HtmlBlockStoryblok } from '$types/bloks';

  export let block: HtmlBlockStoryblok;
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html block.html}
